import { Component, Input, OnChanges, OnInit } from '@angular/core';

@Component({
  selector: 'adp-result-report-table',
  templateUrl: './result-report-table.component.html',
  styleUrls: ['./result-report-table.component.css']
})
export class ResultReportTableComponent implements OnInit, OnChanges {

  @Input() public title: any;
  @Input() public data: any;
  @Input() public totals: any;

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges() {
    // console.log('ngOnChanges', this.data);
  }

}
